import React, { useEffect, useState } from 'react';
import { Card } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { MapPin, ExternalLink, Phone } from 'lucide-react';
import { api } from '../lib/api';

export const LocalPrograms = ({ postal, onPostalSaved }) => {
  const [data, setData] = useState(null);
  const [input, setInput] = useState(postal || '');

  const lookup = async (p) => {
    if (!p || p.replace(/\s/g, '').length < 3) return;
    try { const r = await api.get('/local', { params: { postal: p } }); setData(r.data); } catch { setData(null); }
  };
  useEffect(() => { if (postal) { setInput(postal); lookup(postal); } }, [postal]);

  const save = async () => { await lookup(input); onPostalSaved?.(input); };

  return (
    <Card className="p-5 sm:p-6 bg-card mb-8" data-testid="local-programs">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <div>
          <h2 className="text-lg font-semibold flex items-center gap-2" style={{fontFamily: 'Lexend'}}><MapPin className="w-5 h-5 text-primary" /> Local programs near you</h2>
          <p className="text-sm text-muted-foreground mt-1">Municipal housing, transit discounts and paratransit depend on where you live. {data?.region ? <span className="text-foreground font-medium">Showing {data.region}.</span> : 'Enter your postal code (first 3 characters is enough).'}</p>
        </div>
        <div className="flex gap-2">
          <Input value={input} onChange={(e) => setInput(e.target.value.toUpperCase())} placeholder="e.g. M5V" maxLength={7} className="h-11 w-32 uppercase" data-testid="postal-input" aria-label="Postal code" />
          <Button onClick={save} className="h-11 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="postal-lookup-btn">Look up</Button>
        </div>
      </div>
      {data && !data.region && <p className="text-sm text-muted-foreground mt-4" data-testid="local-none">We don't have municipal data for {data.fsa} yet — we currently cover Toronto, Ottawa, Hamilton, Peel, York, Waterloo, London, Durham, Niagara, Windsor-Essex and Simcoe County. Provincial and federal programs above still apply.</p>}
      {data?.programs?.length > 0 && (
        <div className="grid md:grid-cols-2 gap-3 mt-5">
          {data.programs.map((p) => (
            <div key={p.id} className="rounded-xl border border-border p-4" data-testid={`local-program-${p.id}`}>
              <div className="flex gap-1.5 mb-1.5 flex-wrap"><Badge variant="outline">{p.type}</Badge><Badge variant="outline">{data.region.split(' (')[0]}</Badge></div>
              <div className="font-semibold" style={{fontFamily: 'Lexend'}}>{p.name}</div>
              <p className="text-sm text-muted-foreground mt-1">{p.summary}</p>
              <div className="text-sm mt-2"><span className="text-muted-foreground">Value:</span> <span className="font-semibold text-primary">{p.estimated_amount}</span></div>
              <p className="text-xs text-muted-foreground mt-1">{p.eligibility_note}</p>
              <div className="flex gap-3 mt-2 text-xs"><a href={p.url} target="_blank" rel="noopener noreferrer" className="text-primary underline flex items-center gap-1">Official site <ExternalLink className="w-3 h-3" /></a><span className="flex items-center gap-1 text-muted-foreground"><Phone className="w-3 h-3" /> {p.phone}</span></div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};
